import React from 'react';
import {
  DatabaseOutlined,
  WalletOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileProtectOutlined,
} from '@ant-design/icons';

export const routeList = [
  {
    key: 'sub21',
    title: 'Өгөгдөл боловсруулах',
    text: 'Өгөгдөл боловсруулах',
    tText: 'noatBolovsruulah',
    icon: <DatabaseOutlined className="fs-20" />,
    url: '/hhoat/history',
    nodeId: '1',
  },
  {
    key: 'sub22',
    title: 'Нийгмийн даатгалын шимтгэл ногдуулалт',
    text: 'Нийгмийн даатгалын шимтгэл ногдуулалт',
    tText: 'hhoatBorluulalt',
    icon: <WalletOutlined className="fs-20" />,
    url: '/hhoat/borluulalt',
    nodeId: '2',
  },
  {
    key: 'sub26',
    title: 'XM 11.1',
    text: 'XM 11.1',
    tText: 'hhoatHm11_1',
    icon: <FileTextOutlined className="fs-20" />,
    url: '/hhoat/hm11_1',
    nodeId: '3',
  },
  {
    key: 'sub27',
    title: 'XM 11.2',
    text: 'XM 11.2',
    tText: 'hhoatHm11_2',
    icon: <FileDoneOutlined className="fs-20" />,
    url: '/hhoat/hm11_2',
    nodeId: '4',
  },
  {
    key: 'sub28',
    title: 'XM 11.3',
    text: 'XM 11.3',
    tText: 'hhoatHm11_3',
    icon: <FileSearchOutlined className="fs-20" />,
    url: '/hhoat/hm11_3',
    nodeId: '5',
  },
  {
    key: 'sub29',
    title: 'ТТ-11',
    text: 'ТТ-11',
    tText: 'hhoatTailan',
    icon: <FileProtectOutlined className="fs-20" />,
    url: '/hhoat/tailan',
    nodeId: '7',
  },
  {
    key: 'sub7-3',
    text: 'E-tax',
    tText: 'e_tax',
    icon: <FileProtectOutlined className="fs-20" />,
    url: '/hhoat/e_tax',
    nodeId: '23',
  },
];

export const _menu = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
  [10, 11, 12],
];

export const settings = {
  dots: false,
  infinite: true,
  arrows: false,
  swipe: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
};
